import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20dark%20theater%20with%20red%20velvet%20curtains%20and%20golden%20spotlights%2C%20dramatic%20stage%20lighting%2C%20empty%20luxurious%20cinema%20hall%20with%20warm%20ambient%20glow%2C%20professional%20atmospheric%20photography%2C%20rich%20dark%20tones%20with%20golden%20accents&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="农民影视 - 免费高清影视在线观看"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <div className="max-w-3xl">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            免费高清影视
            <span className="block text-accent-400">在线观看不缓冲</span>
          </h1>
          <p className="text-base md:text-lg text-background-200/90 mb-8 max-w-xl mx-auto leading-relaxed">
            涵盖高清电影免费看、电视剧免费全集，高清流畅播放体验，即点即播无需等待，尽享影视盛宴
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/dongzuo"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-all whitespace-nowrap text-sm"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即观看
            </Link>
            <Link
              to="/category/dianshiju"
              className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full border border-white/30 transition-all whitespace-nowrap text-sm"
            >
              <i className="ri-tv-line mr-2"></i>
              热门电视剧
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 md:gap-10 mt-10">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">10万+</div>
              <div className="text-xs text-background-300 mt-1">影视资源</div>
            </div>
            <div className="w-px h-10 bg-background-200/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">5,800万+</div>
              <div className="text-xs text-background-300 mt-1">累计用户</div>
            </div>
            <div className="w-px h-10 bg-background-200/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">98.6%</div>
              <div className="text-xs text-background-300 mt-1">好评率</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}